<script lang="ts">
// Hold offer data here
// all editors hit the lodash method to save on key down...
// perhaps they have an internal one so that they only save their own data?
import Research from "../components/Research.svelte";
import Editor from "../components/Editor.svelte";
import Brief from "../components/Brief.svelte";
import CopyOutline from "../components/CopyOutline.svelte"
import Mechanism from "../components/Mechanism.svelte";
import { auth, functions } from "../services/firebase";
import router from "page";
import debounce from 'lodash-es/debounce'

import { onMount } from "svelte";

import Fa from "svelte-fa";
// import { fa } from '@fortawesome/free-regular-svg-icons'
import {
  faGlasses,
  faCopy,
  faPenFancy,
  faArrowLeft,
  faShareAlt
} from "@fortawesome/free-solid-svg-icons";
import { fade, fly } from "svelte/transition";
import { Offer } from "../models/Offer";
import { EditorMode } from "../models/EditorMode";
import type { Letter } from "../models/Letter";
import ShareModal from "../components/ShareModal.svelte";

export let params: { offerID: string};
export let qs : {shareKey?:string};

interface User {
  email: string;
  photoURL: string;
  uid: string;
}

let scheduledSaveProperties = new Set();
let scheduledSaveLetters = new Set();

let user: User | null;
let loading = true;
let successfulLoad = false;
let letterAdding = false;
let saving = false;
let saveStatus = "";
let nameFocus = false;
let readOnlyMode = false;
auth.onAuthStateChanged((u) => (user = u));

async function saveOffer(){
  if(!successfulLoad || readOnlyMode){ return;}

    console.log("Saving")
    saving = true;
    console.log(scheduledSaveLetters);
    console.log(scheduledSaveProperties);
    const saveObject = {
      offerID: params.offerID,
      offer: {},
      letters: []
    };

    if(scheduledSaveProperties.size > 0){
        scheduledSaveProperties.forEach((propertyKey: string) => {
            saveObject["offer"][propertyKey] = offer[propertyKey];
            console.log(offer[propertyKey])
        })
    }

    if(scheduledSaveLetters.size > 0){
        saveObject["letters"] = offer.letters.filter((letter:Letter)=>{
            return scheduledSaveLetters.has(letter.id)
        })
    }

    console.log("Saving object", saveObject)
    if(scheduledSaveProperties.size > 0 || scheduledSaveLetters.size > 0){
      try {
        saveStatus = "Saving...";

        console.log("Calling save", saveObject)

        const offerCall = await functions.httpsCallable("updateOffer")(saveObject);

        scheduledSaveProperties.clear();
        scheduledSaveLetters.clear();
        saveStatus = "Saved.";

      } catch (error) {
        console.log("Error saving offer", error);
        saveStatus = "Save failed.";
        debouncedSaveOffer();
      } finally {
        loading = false;
        saving = false;
      }
    }
}
const debouncedSaveOffer = debounce(saveOffer, 8000);

async function flushSaves(){
  await debouncedSaveOffer.flush()
}

function scheduleOfferDataPropertySave(propObject, prop) {
  if(readOnlyMode) return;
  // console.log(prop);
  saveStatus = "DRAFT";
  scheduledSaveProperties.add(prop);
  if(offer != null && offer[prop] != null){
    if(typeof propObject === "string"){
      // offer[prop] = propObject;
      if(prop === "name"){
        // console.log(propObject)
        if(propObject.length >= 1){
          name = propObject
          Object.assign(offer, {name: propObject});
        } else {
          saveStatus = "Can't save empty name"
          if(propObject == "" && offer.name != ""){
            name = offer.name;
          }
        }
      }
    }else{
      Object.assign(offer[prop], propObject);
    }
 
  } else{
    if(offer != null && prop === "name"){
        // console.log(propObject)
        if(name == null){
          // console.log(offer)
          Object.assign(offer, {name: propObject});
        }
        if(propObject == "" && offer.name != ""){
          name = offer.name;
        }
        else if(propObject == null){
          propObject = "";
          name = propObject
          Object.assign(offer, {name: propObject});
        } else{
          name = propObject
          Object.assign(offer, {name: propObject});
        }
        
      }
  }

  debouncedSaveOffer();
}

function saveLetterData(letter: CustomEvent<{prop: string}>) {
  // console.log(letter.detail.prop);
  if(readOnlyMode) return;
  saveStatus = "DRAFT";
  scheduledSaveLetters.add(letter.detail.prop)
  debouncedSaveOffer();
}
$: {
  // change to if user null aaaand readOnlyKey === null
  if (user === null && qs.shareKey === null) router.redirect("/auth?action=login&next=%2Fdashboard");
}

/* After offer is retrieved, make it reactive such that
it triggers a lodash method to save it. All editors simply send edits to this object*/
let offer: Offer = new Offer();
$: ({ research, mechanism, brief, editorSettings, name, letters } = offer);

$: scheduleOfferDataPropertySave(research, "research");
$: scheduleOfferDataPropertySave(mechanism, "mechanism");
$: scheduleOfferDataPropertySave(brief, "brief");
$: scheduleOfferDataPropertySave(editorSettings, "editorSettings");
$: scheduleOfferDataPropertySave(name, "name");
$: document.title = "PersuAId – " + name;
// let research;

// saveLetterData(letters);

onMount(async () => {
  // functions.useEmulator("localhost", 5001)
  try {
    const offerCall = await functions.httpsCallable("getOffer")({
      offerID: params.offerID,
      shareKey: qs.shareKey
    });
    console.log(qs.shareKey)
    if(qs?.shareKey && qs?.shareKey?.length > 0){
      console.log("Read only mode true")
      readOnlyMode = true;
      saveStatus = "Read-Only Mode"
    }
    console.log(offerCall.data)
    Object.assign(offer, offerCall.data);
    letters = [...offerCall.data.letters]
    $: ({ research, mechanism, brief, editorSettings, name } = offer);
    setTimeout(()=>{
      //prevents reactive re-saving on first load.
      saveStatus = "";
      setTimeout(()=>{
        scheduledSaveProperties.clear();
        scheduledSaveLetters.clear();
        if(readOnlyMode){
          saveStatus = "Read-Only Mode"
        }
      }, 1000)
    }, 100)
    successfulLoad = true;
    $: document.title = "PersuAId " + name;
  } catch (error) {
    console.log("Error retrieving offer", error);
    router.show("/")
  } finally {
    loading = false;
  }
  console.log(params);
});
function researchMode() {
  editorSettings.currentMode = EditorMode.RESEARCH;
}

async function addLetter(){
  if(letters.length >= 5){
    return;
  }
  letterAdding = true;
  try {
    const offerCall = await functions.httpsCallable("newLetter")({
      offerID: params.offerID,
      currentLettersLength: letters.length
    });
    console.log(offerCall.data)
    // Object.assign(offer, offerCall.data);
    letters = [...offer.letters, offerCall.data]
    Object.assign(offer.letters, letters)
    // letters.push(offerCall.data)
    setTimeout(()=>{
      //prevents reactive re-saving on first load.
      // scheduledSaveProperties.clear();
      // scheduledSaveLetters.clear();
    }, 500)
    
  } catch (error) {
    console.log("Error retrieving offer", error);
  } finally {
    letterAdding = false;
  }
}

function goUp(){
  flushSaves();
  let destination;
  if(readOnlyMode){
    destination = `/dashboard`;
  } else {
    if(offer && offer.offerOwnerKey){
      destination = `/offers?offerOwner=${offer.offerOwnerKey}`
    }else{
      destination = `/dashboard`;
    }
  }

  router.redirect(destination)
}

async function logout() {
    console.log("Logging out...")
    await flushSaves();
    if (auth.currentUser) {
        auth.signOut().then(() => {
          router.show("/")
        }).catch(e => {
            router.show("/")
            throw new Error(e)
        });
    }
}
let shareModal;
</script>
<ShareModal bind:this={shareModal} offerID={params.offerID} />
<main>
{#if typeof user === "undefined" || loading}
  <div class="w-screen h-screen text-center justify-center i pt-6">
      <i class="fas fa-spinner fa-spin fa-5x"></i> 
      <p>Loading</p>
  </div>
{:else}
<div id="editorModeNav">
  {#if user != null}
  <div
    on:click={goUp}
    title="Research Mode"
    class="tab left items-center flex max-h-16 "
  >
    <Fa icon={faArrowLeft} color="black" size="3x" swapOpacity={false} />
  </div>
  {/if}
  <div
    on:click={researchMode}
    title="Research Mode"
    class="tab items-center flex max-h-16  tooltip"
    class:bg-secondary={editorSettings.currentMode === "RESEARCH"}
  >
    <Fa icon={faGlasses} color="black" size="3x" swapOpacity={false} />
    <span class="tooltiptext">Research Mode</span>
  </div>
  <div
    on:click={() => (editorSettings.currentMode = EditorMode.COPY)}
    title="Copy Mode"
    class="tab items-center flex max-h-16  tooltip
      {editorSettings.currentMode ===
    'COPY'
      ? 'bg-secondary'
      : ''}"
  >
    <Fa icon={faCopy} color="black" size="3x" swapOpacity={false} />
    <span class="tooltiptext">Copy Mode</span>
  </div>
  <div
    on:click={() => (editorSettings.currentMode = EditorMode.WRITING)}
    title="Writing Mode"
    class="tab right items-center flex max-h-16 tooltip
      {editorSettings.currentMode ===
    'WRITING'
      ? 'bg-secondary'
      : ''}"
  >
    <Fa icon={faPenFancy} color="black" size="3x" swapOpacity={false} />
    <span class="tooltiptext">Writing Mode</span>
  </div>
  {#if !readOnlyMode}
  <div>
    <button 
      on:click={()=>{shareModal.show()}}
      class="
      text-white
      hover:bg-red-300 
      p-2 
      float-right 
      tooltip
      mr-1
      rounded-lg">
      <Fa icon={faShareAlt} color="black" size="2x" swapOpacity={false} />
      <span class="tooltiptext">Share Read-Only Link</span>
    </button>
  </div>
  {/if}
  <div class="p-4 font-mono text-gray-800 text-lg">
    <h2 
    bind:textContent={name}
    on:blur={()=> nameFocus = false}
    on:focus={(evt)=> {
      if(readOnlyMode){
        evt.currentTarget.blur();
      }
      console.log(evt)
      nameFocus = true}}
    class:border-gray-400={name == null || name == ""}
    class="p-0.5 {nameFocus ? "" : "max-h-7 overflow-y-hidden overflow-ellipsis"}" 
    style="min-width: 200px;" contenteditable="true">
    </h2>
  </div>
  <div class="justify-self-end float-right ml-auto p-4 font-mono text-gray-500">
    <h2 class="cursor-pointer" on:click={flushSaves}>
      {saveStatus}
    </h2>
  </div>
<div class="float-right justify-self-end pt-2 pr-2">
  {#if user != null}
  <button class="text-white
      hover:bg-red-300 
      p-2 
      bg-third
      rounded-lg" on:click={logout}>
      Logout
  </button>
  {/if}
</div>
</div>
<br />
<!-- {#ifeditorSettings.currentMode === "COPY"}
<Mechanism {currentMode}/>
{/if} -->
<div class="screenTabContainer">
  <div class="tabContainer" id="leftTabs">
    {#if editorSettings.currentMode === EditorMode.RESEARCH}
      <h3
        in:fly|local={{ delay: 250 }}
        out:fade|local
        class="documentTab {editorSettings.currentTabs.RESEARCH.leftTab === 0
          ? 'active'
          : 'inactive'}"
        on:click={() => {
          editorSettings.currentTabs.RESEARCH.leftTab = 0;
        }}
      >
        Research
      </h3>
    {:else if editorSettings.currentMode === EditorMode.COPY}
      <h3
        in:fly|local={{ delay: 250 }}
        out:fade|local
        class="documentTab {editorSettings.currentTabs.COPY.leftTab === 0
          ? 'active'
          : 'inactive'}"
        on:click={() => {
          editorSettings.currentTabs.COPY.leftTab = 0;
        }}
      >
        Research
      </h3>
      <h3
        in:fly|local={{ delay: 250 }}
        out:fade|local
        class="documentTab {editorSettings.currentTabs.COPY.leftTab === 1
          ? 'active'
          : 'inactive'}"
        on:click={() => {
          editorSettings.currentTabs.COPY.leftTab = 1;
        }}
      >
        Mechanism
      </h3>
      <h3
        in:fly|local={{ delay: 250 }}
        out:fade|local
        class="documentTab {editorSettings.currentTabs.COPY.leftTab === 2
          ? 'active'
          : 'inactive'}"
        on:click={() => {
          editorSettings.currentTabs.COPY.leftTab = 2;
        }}
      >
        Brief
      </h3>
      {#if !readOnlyMode}
        <h3
        in:fly|local={{ delay: 250 }}
        out:fade|local
        class="documentTab {editorSettings.currentTabs.COPY.leftTab === 3
          ? 'active'
          : 'inactive'}"
        on:click={() => {
          editorSettings.currentTabs.COPY.leftTab = 3;
        }}
        >
        Outline
        </h3>
        {/if}
    {:else if editorSettings.currentMode === EditorMode.WRITING}
    <div class="mechanismsLettersTabContainer">
      <div class="letterTabs">
        <h3
          in:fade|local={{ delay: 250 }}
          out:fade|local
          class="documentTitleTab"
        >
          Letters:
        </h3>
        <!-- for each over letters to generate tabs -->
        {#each letters as letter, i}
          <h3
            in:fade|local={{ delay: 250 }}
            out:fade|local
            class="letterTab {editorSettings.currentTabs.WRITING.leftTab === i
              ? 'active'
              : 'inactive'} px-4"
   
            on:click={() => {
              editorSettings.currentTabs.WRITING.leftTab = i;
            }}
          >
            {letter.name}
            <!-- {String.fromCharCode(65 + i)} -->
          </h3>
        {/each}
        <h3
          in:fly|local={{ delay: 250 }}
          out:fade|local
          class="documentTab actionTab ml-4 hover:bg-third hover:text-white
          {(letterAdding || letters.length >= 5 || readOnlyMode)? 'opacity-50 pointer-events-none' : ''}"
           disabled={(letterAdding || letters.length >= 5 || readOnlyMode)}
           on:click={addLetter}
          >
          +
        </h3>

      </div>
    </div>
    {/if}
  </div>
  <div class="tabContainer" id="rightTabs">
    {#if editorSettings.currentMode === EditorMode.RESEARCH}
      <h3
        in:fly|local={{ delay: 250 }}
        out:fade|local
        class="documentTab {editorSettings.currentTabs.RESEARCH.rightTab === 0
          ? 'active'
          : 'inactive'} max-h-36"
        on:click={() => {
          editorSettings.currentTabs.RESEARCH.rightTab = 0;
        }}
      >
        Mechanism
      </h3>
      <h3
        in:fly|local={{ delay: 250 }}
        out:fade|local
        class="documentTab {editorSettings.currentTabs.RESEARCH.rightTab === 1
          ? 'active'
          : 'inactive'} max-h-36"
        on:click={() => {
          editorSettings.currentTabs.RESEARCH.rightTab = 1;
        }}
      >
        Brief
      </h3>
    {:else if editorSettings.currentMode === EditorMode.COPY}
      <div class="mechanismsLettersTabContainer">
        <div class="letterTabs">
          <h3
            in:fade|local={{ delay: 250 }}
            out:fade|local
            class="documentTitleTab"
          >
            Letters:
          </h3>
          <!-- for each over letters to generate tabs -->
          {#each letters as letter, i}
            <h3
              in:fade|local={{ delay: 250 }}
              out:fade|local
              class="letterTab {editorSettings.currentTabs.COPY.rightTab === i
                ? 'active'
                : 'inactive'} px-4"
     
              on:click={() => {
                editorSettings.currentTabs.COPY.rightTab = i;
              }}
            >
              {letter.name}
              <!-- {String.fromCharCode(65 + i)} -->
            </h3>
          {/each}

          <h3
          in:fly|local={{ delay: 250 }}
          out:fade|local
          class="documentTab actionTab ml-4 hover:bg-third hover:text-white
          {(letterAdding || letters.length >= 5 || readOnlyMode)? 'opacity-50 pointer-events-none' : ''}"
           disabled={(letterAdding || letters.length >= 5 || readOnlyMode)}
           on:click={addLetter}
          >
          +
        </h3>
        </div>
      </div>
    {:else if editorSettings.currentMode === EditorMode.WRITING}
    <div class="mechanismsLettersTabContainer">
      {#if letters.length > 1}
      <div class="letterTabs">
        <h3
          in:fade|local={{ delay: 250 }}
          out:fade|local
          class="documentTitleTab"
        >
          Letters:
        </h3>
        <!-- for each over letters to generate tabs -->
        {#each letters as letter, i}
          <h3
            in:fade|local={{ delay: 250 }}
            out:fade|local
            class="letterTab {editorSettings.currentTabs.WRITING.rightTab === i
              ? 'active'
              : 'inactive'} px-4"
   
            on:click={() => {
              editorSettings.currentTabs.WRITING.rightTab = i;
            }}
          >
            {letter.name}
            <!-- {String.fromCharCode(65 + i)} -->
          </h3>
        {/each}

        <h3
        in:fly|local={{ delay: 250 }}
        out:fade|local
        class="documentTab actionTab ml-4 hover:bg-third hover:text-white
        {(letterAdding || letters.length >= 5 || readOnlyMode)? 'opacity-50 pointer-events-none' : ''}"
         disabled={(letterAdding || letters.length >= 5 || readOnlyMode)}
         on:click={addLetter}
        >
          +
        </h3>
      </div>
      {/if}
    </div>
    {/if}
  </div>
</div>

<div class="editingContainer">
  <div class="{letters.length == 1 && editorSettings.currentMode === EditorMode.WRITING ? "leftEditorsFullWidth" : "leftEditors"} {editorSettings.currentMode === EditorMode.WRITING && letters.length === 1 ? " w-0" : ""}">
    {#if (editorSettings.currentMode === EditorMode.RESEARCH && 
    editorSettings.currentTabs.RESEARCH.leftTab === 0) || 
    (editorSettings.currentMode === EditorMode.COPY && 
    editorSettings.currentTabs.COPY.leftTab === 0)}
      <Research readOnlyMode={readOnlyMode} bind:research />
    {:else if editorSettings.currentMode === EditorMode.COPY}
      <!-- {#if currentleftTab == 0} 
              <Research/> -->
      {#if editorSettings.currentTabs.COPY.leftTab === 1}
        <Mechanism readOnlyMode={readOnlyMode} bind:mechanism />
      {:else if editorSettings.currentTabs.COPY.leftTab === 2}
        <Brief readOnlyMode={readOnlyMode} bind:brief />
      {:else if editorSettings.currentTabs.COPY.leftTab === 3 && !readOnlyMode}
        <CopyOutline />
      {/if}
    {:else}
      <Editor
      readOnlyMode={readOnlyMode}
      fullWidth={letters.length == 1}
      leftRight="L"
      on:saveletter={saveLetterData}
      bind:letter={letters[editorSettings.currentTabs.WRITING.leftTab]}
      currentLetterIndex={editorSettings.currentTabs.WRITING.leftTab}
      currentMode={editorSettings.currentMode}
      />

    {/if}
  </div>
  <div class="rightEditors {editorSettings.currentMode === EditorMode.WRITING && letters.length === 1 ? "w-screen" : ""}">
    {#if editorSettings.currentMode === EditorMode.RESEARCH}
      {#if editorSettings.currentTabs.RESEARCH.rightTab === 0}
        <Mechanism bind:mechanism />
      {:else if editorSettings.currentTabs.RESEARCH.rightTab === 1}
        <Brief bind:brief />
      {/if}
    {:else if editorSettings.currentMode === EditorMode.COPY || 
    (editorSettings.currentMode === EditorMode.WRITING && letters.length > 1)}
      <Editor
        readOnlyMode={readOnlyMode}
        leftRight="R"
        fullWidth={false}
        on:saveletter={saveLetterData}
        bind:letter={letters[editorSettings.currentTabs[editorSettings.currentMode].rightTab]}
        currentLetterIndex={editorSettings.currentTabs[editorSettings.currentMode].rightTab}
        currentMode={editorSettings.currentMode}
      />
    <!-- {:else}
      {#if letters.length > 1}
        <Editor
        leftRight="R"
        fullWidth={false}
        on:saveletter={saveLetterData}
        bind:letter={letters[editorSettings.currentTabs.WRITING.rightTab]}
        currentLetterIndex={editorSettings.currentTabs.WRITING.rightTab}
        currentMode={editorSettings.currentMode}
        />
      {/if} -->
    {/if}
  </div>
</div>
{/if}
</main>

<style>
main {
  display: flex;
  flex-direction: column;
  /* max-height: 100%; */
}

:global(body) {
  background-color: #fdf5e6 !important;
  /* max-height: 100%; */
  height: 100%;
  width: 100%;
  margin: 0;
  /* position: absolute; */
}
:global(html) {
  height: 100%;
  width: 100%;
  margin: 0;
}
.mechanismsLettersTabContainer {
  display: flex;
  flex-direction: column;
}
.mechanismsSpan {
  vertical-align: middle;
  text-align: center;
  margin: auto;
}
.letterTabs {
  display: flex;
  flex-direction: row;
  flex: 1;
}
.mechanismTabs {
  display: flex;
  flex-direction: row;

  flex: 1;
}

#editorModeNav {
  width: 100%;
  display: flex;
  flex-direction: row;
  padding-left: 5vw;
  /* justify-content: center; */
}
.editingContainer {
  max-width: 100vw;
  /* max-height: 83vh; */
  display: flex;
  flex-direction: row;
  /* position: absolute; */
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.screenTabContainer {
  display: flex;
  @apply border-black border-solid border-b-2
}
.tabContainer {
  display: flex;
  flex-direction: row;
  flex: 0.5;
}

.leftEditors {
  max-width: 50%;
  max-height: 83vh;
  overflow-y: scroll;
  @apply border-black border-solid border;
}

.leftEditorsFullWidth {
  max-width: 100vw;
  max-height: 83vh;
  /* @apply border-black border-solid border-t-2; */
}

.rightEditors {
  width: 50vw;
  max-width: 50%;
  max-height: 83vh;
  overflow-y: scroll;
  @apply border-black border-solid border;
}

.documentTab {
  font-size: x-large;
  cursor: pointer;
  padding-left: 10px;
  padding-right: 10px;
}

.letterTab {
  font-size: x-large;
  cursor: pointer;
}

.letterTab.active {
  cursor: default;
}
.letterTab.inactive {
  @apply hover:bg-yellow-500 hover:text-white;
  @apply border-r border-t border-gray-300 border-dotted;
}

.documentTitleTab {
  font-size: x-large;
  padding-left: 10px;
  padding-right: 10px;
}

.documentTab.actionTab {
  cursor: pointer;
}

.documentTab.active {
  cursor: default;
}
.documentTab.inactive {
  @apply hover:bg-yellow-500 hover:text-white;
  @apply border-r border-t border-gray-300 border-dotted;
}

.tab {
  cursor: pointer;
  padding: 3px 15px 3px 15px;
  border-left: black solid 2px;
  border-right: black solid 2px;
  border-bottom: black solid 2px;
}
.left {
  border-radius: 0px 0px 0px 5px;
}
.right {
  border-radius: 0px 0px 5px 0px;
}

.tooltip {
  position: relative;
  display: inline-block;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  top: 100%;
  left: 50%;
  margin-left: -60px;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}

.active {
  border: black 1px solid;
  border-radius: 5px 5px 0px 0px;
}

.actionTab {
  border: black 1px solid;
  border-radius: 5px 5px 0px 0px;
}

.inactive {
  color: rgb(255, 255, 255);
  background-color: peachpuff;
}
</style>
  